<template>
  <component v-bind:is="layout"></component>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import SensorsChoice from '@/components/SensorsChoice.vue'; // @ is an alias to /src
import axios from 'axios';

import LoginLayout from './layouts/LoginLayout.vue';
import SimpleLayout from './layouts/SimpleLayout.vue';
import DefaultLayout from './layouts/DefaultLayout.vue';

function camelize(str: string) {
  const arr = str.split('-');
  const capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item.toLowerCase());
  // ^-- change here.
  const capitalString = capital.join('');
  return capitalString;
}

function to_component_name(str: string) {
  const arr = str.split('-');
  const capital = arr.map((item, index) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase());
  // ^-- change here.
  const capitalString = capital.join('');
  return capitalString;
}

@Component({
  components: {
    LoginLayout,
    SimpleLayout,
    DefaultLayout,
  },
})
export default class App extends Vue {
  private authenticated: boolean = false;
  private git_version: string = '1.0';
  private username: string = '';
  private avatar: string = '';

  public about() {
    const self = this;

    const headers = self.$store.getters.DefaultHeaders;

    return axios
      .post(window.VUE_BMOS_WEB_API + '/about', '', headers)
      .then((response) => {
        return false;
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error.response.data);
          return false;
        }
      });
  }

  public async created() {
    const self = this;

    if (!this.$store.getters.isAuthenticated) {
      this.$router.replace({ name: 'login' });
    }
    else {

      console.log("Authenticated in App");
    }

  }

  public mounted() {
    console.log('mounted App');
  }

  public async setAuthenticated(status: any) {
    this.authenticated = status;
  }

  get layout(): string {

    // const components = this.$options.components;

    // const component = to_component_name(this.$store.getters.Layout);

    // if (components !== null && components !== undefined && (component in components)) {
    //   return this.$store.getters.Layout;
    // }

    if (!this.$store.getters.isAuthenticated) {
      return 'login-layout';
    }

    return 'default-layout';
  }

  public logout() {
    this.authenticated = false;
    this.$store.commit('logOut');
    this.$store.commit('setLayout', 'login-layout');
  }
}
</script>

<style lang="less">
// body {
//     background-color: #f0f0f0;
// }
// h1 {
//     padding: 0;
//     margin-top: 0;
// }
// #app {
//     margin: 5px;
// }
</style>
